import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AcessoCidadaoServico {
  Url: string;

  constructor(private http: Http) { }

  inicializarConfiguracoes() {
    return new Promise((resolve, reject) => {
      this.http.get('assets/config.json').subscribe(
        (data) => {
          this.Url = data.json().BASE_WEB_API;
          resolve(true);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  UrlDeAutorizacao() {
    return new Promise((resolve, reject) => {
      this.http.get(this.Url + 'api/Login/GetAcessoCidadaoAutorizacao')
        .pipe(map((response: Response) => response.json()))
        .subscribe(
          data => {
            localStorage.setItem('code_verifier', data.codeVerifier);
            localStorage.setItem('auth_state', data.State);

            const redirectUri = data.redirectUri;
            window.location.href = redirectUri;
            resolve(redirectUri);
          },
          error => {
            reject(error);
          }
        );
    });
  }
}